angular.
module("dx.webapp.question").
constant("DX_QUESTION_TYPE", Object.freeze({
	TEXT: 0,
	SINGLE_CHOICE: 1,
	MULTIPLE_CHOICE: 2,
	WORD_GAP: 3,
}));
